import { createElement } from "react"
import { Slot } from "@radix-ui/react-slot"
import { IconBaseProps } from "react-icons"

import { IconSizeEnum } from "@/types/app"
import { getIconSize } from "@/lib/utils"
import { getIconComponent } from "@/components/icons/RemixIconList"

type TIconSize = keyof typeof IconSizeEnum

type TRemixIconProps = Omit<IconBaseProps, "size"> & {
  name: string
  className?: string
  size?: TIconSize
}

const RemixIcon = ({
  name,
  className,
  size = "sm",
  ...iconProps
}: TRemixIconProps) => {
  const IconComponent = getIconComponent(name)

  if (!IconComponent) {
    return null
  }

  const iconSize = getIconSize(size)

  return (
    <Slot>
      {createElement(IconComponent, {
        className,
        size: iconSize,
        ...iconProps,
      })}
    </Slot>
  )
}

export { RemixIcon, type TRemixIconProps, type TIconSize }
